/* Copyright (C) Envialo México SA de CV - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by:
 * @author América Mendoza  <amendoza@nodeport.co>,
 * @author Darién Miranda <dmiranda@nodeport.co>,
 * @author Oscar Peña <opena@nodeport.co>,
 * August 2025
 */

import React from 'react';
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import {withRouter} from "react-router";
import Modal from "react-bootstrap/Modal";
import ModalBody from "react-bootstrap/ModalBody";
import ModalFooter from "react-bootstrap/ModalFooter";
import ModalHeader from "react-bootstrap/ModalHeader";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import NbioApi from "../../lib/api/NbioApi";
import PropTypes from "prop-types";


class CreateRouteModal extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            name: '',
        }

        this.createRoute = this.createRoute.bind(this);
    }


    createRoute(){
        const name = this.state.name;

        if(name.trim() !== ''){
            const route = this.props.orderId ? {name: name, orders: [this.props.orderId]} : {name:name,orders:[]}

            NbioApi.routes.create(route).then((res) => {
                const routeCreated = res.data?.route;
                this.setState({name:""});
                this.props.onRouteCreated(routeCreated)
            }).catch((ex) => {
                let errorMsg = 'Hubo un error al crear a la ruta';
                this.setState({name:""});
                this.props.onRouteCreationFailed()
            })
        }
    }

    render(){
        return(
            <Modal show={this.props.show}>
                <ModalHeader closeButton onHide={() => {this.setState({name: ''}, () => {this.props.onRouteCreationCanceled()})}}>
                    <h5>Crear nueva ruta</h5>
                </ModalHeader>
                <ModalBody>
                    <Container fluid className={''}>
                        <Row className={'my-3'}>
                            <Col sm={12} md={12}>
                                <Form.Control type="text"
                                              placeholder="Escribe el nombre de la ruta"
                                              value={this.state.name}
                                              onKeyUp={(ev) =>{
                                                  if(ev.keyCode === 13) {
                                                      this.createRoute();
                                                  }
                                              }}
                                              onChange={event => this.setState({name:event.target.value})}
                                />
                            </Col>
                        </Row>
                    </Container>
                </ModalBody>
                <ModalFooter>
                    <Button variant="light"
                            onClick={() => {this.setState({name: ''}, () => {this.props.onRouteCreationCanceled()})}}>
                        Cancelar
                    </Button>
                    <Button variant="primary"
                            onClick={() => this.createRoute()}
                            disabled={this.state.name.trim() === ""}>Crear ruta</Button>
                </ModalFooter>
            </Modal>

        )
    }
}

export default withRouter(CreateRouteModal);
CreateRouteModal.propTypes    = {
    show:           PropTypes.bool,
    orderId:        PropTypes.string,
    onRouteCreated: PropTypes.any,
    onRouteCreationFailed: PropTypes.any,
    onRouteCreationCanceled: PropTypes.any

}
CreateRouteModal.defaultProps = {
    show:           false,
    orderId:        '',
    onRouteCreated: () => {},
    onRouteCreationFailed: ()=>{},
    onRouteCreationCanceled: ()=>{}
}